<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :viewbox-width="24"
        :viewbox-height="24"
        :color="color"
        @click="$emit('click')"
    >
        <path
            class="a"
            d="M6.75203 20.251C7.71202 20.251 8.56002 19.636 8.87302 18.751H16.631C16.945 19.636 17.793 20.251 18.752 20.251C19.711 20.251 20.56 19.636 20.873 18.751H22.335C22.354 18.751 22.373 18.75 22.392 18.749C23.338 18.681 24.06 17.853 24 16.904L24.001 10.651C24.13 8.65898 22.584 6.89898 20.556 6.75298C20.537 6.75198 20.52 6.75098 20.502 6.75098H15.752V6.00098C15.752 4.75998 14.743 3.75098 13.502 3.75098H2.25203C1.01103 3.75098 0.0020256 4.75998 0.0020256 6.00098V16.501C0.0020256 17.742 1.01103 18.751 2.25203 18.751H4.63103C4.94403 19.636 5.79203 20.251 6.75203 20.251ZM6.75203 17.251C7.16603 17.251 7.50203 17.587 7.50203 18.001C7.50203 18.415 7.16603 18.751 6.75203 18.751C6.33803 18.751 6.00203 18.415 6.00203 18.001C6.00203 17.587 6.33903 17.251 6.75203 17.251ZM18.752 17.251C19.166 17.251 19.502 17.587 19.502 18.001C19.502 18.415 19.166 18.751 18.752 18.751C18.338 18.751 18.002 18.415 18.002 18.001C18.002 17.587 18.338 17.251 18.752 17.251ZM2.25203 17.251C1.83803 17.251 1.50203 16.915 1.50203 16.501V14.251H14.252V17.251H8.87302C8.55902 16.366 7.71103 15.751 6.75203 15.751C5.79303 15.751 4.94403 16.366 4.63103 17.251H2.25203ZM15.752 17.251V8.25098H17.252V11.153C17.266 12.037 17.989 12.751 18.864 12.751H22.502V14.251H21.295C20.881 14.251 20.545 14.587 20.545 15.001C20.545 15.415 20.881 15.751 21.295 15.751H22.502V16.951C22.511 17.115 22.424 17.232 22.299 17.251H20.873C20.559 16.366 19.711 15.751 18.752 15.751C17.793 15.751 16.944 16.366 16.631 17.251H15.752ZM1.50203 12.751V6.00098C1.50203 5.58698 1.83803 5.25098 2.25203 5.25098H13.502C13.916 5.25098 14.252 5.58698 14.252 6.00098V12.751H1.50203ZM18.877 11.251C18.803 11.251 18.753 11.204 18.752 11.141V8.25098H20.473C21.67 8.35098 22.579 9.40298 22.503 10.604V11.251H18.877Z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'TruckRightIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: currentColor;
    stroke: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
